import { subscribeToCitiesList, type City } from '@services/firebase/firestore';
import { useEffect, useState } from 'react';

export const useCities = () => {
  const [cities, setCities] = useState<City[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const unsubscribe = subscribeToCitiesList(
      (citiesData) => {
        setCities(citiesData);
        setLoading(false);
      },
      (err) => {
        console.error('Cities subscription error:', err);
        setError(err.message || 'Failed to load cities');
        setLoading(false);
      }
    );

    return () => {
      unsubscribe();
    };
  }, []);

  return {
    cities,
    loading,
    error,
  };
};
